import {
  DATA_TYPE
} from './const/data-type';
import {
  MESSAGE_TYPE
} from './const/message-type';

class Message {
  stage;

  feedbackType;

  availableTypes;

  _oaid;

  _username;

  _phone;

  _post;

  _projectCode;

  _messageList;

  _dispatchStatus;

  /**
   * 设置用户信息
   */
  init(data) {
    const {
      user,
      messageList,
      projectCode
    } = data;
    this.setUserInfo(user)
    this._projectCode = projectCode;
    this._messageList = messageList;
  }

  getUserInfo() {
    return {
      oaid: this._oaid,
      username: this._username,
      phone: this._phone,
      post: this._post
    };
  }

  setUserInfo(user) {
    const {
      oaid = '',
        username = '',
        phone = '',
        post = '',
    } = user;
    this._oaid = oaid;
    this._username = username;
    this._phone = phone;
    this._post = post;
  }

  handleChat(data) {
    if (data.stage) {
      this.stage = data.stage;
    }
    this.dispatchMessage(data.data);
  }

  /**
   * 分发收到的消息给处理函数, 目前仅需要根据消息来源区分即可
   * @param message {{from: String, messageType: String, data: Object, dataType: String}}
   */
  dispatchMessage(message, dispatchStatus = 'normal') {
    this._dispatchStatus = dispatchStatus;
    if (message.from === 'monkey') {
      this.dispatchByMessage(message);
    } else {
      this.dispatchByData(message);
    }
  }

  /**
   * 分发业务敏感的消息给专用处理函数
   * @param message {{from: String, messageType: String, data: Object, dataType: String}}
   */
  dispatchByMessage(message) {
    switch (message.messageType) {
      case MESSAGE_TYPE.SEARCH_RESULT:
        this.handleSearchResult(message);
        break;
      case MESSAGE_TYPE.AVAILABLE_TYPES:
        this.handleAvailableTypes(message);
        break;
      case MESSAGE_TYPE.READY_TO_LISTEN:
        this.handleReadyToListen(message);
        break;
      case MESSAGE_TYPE.FEEDBACK_RECEIVED:
        this.handleFeedbackReceive(message);
        break;
    }
  }

  /**
   * 分发简单消息给处理函数
   * @param message {{from: String, dataType: String, data: Object, messageType: String}}
   */
  dispatchByData(message) {
    if (message.dataType === DATA_TYPE.IMAGE) {
      this.generateImage(message);
    } else if (message.dataType === DATA_TYPE.TEXT) {
      this.generatePlainText(message);
    }
  }

  assembleMessage(messageType, dataType, data) {
    const message = {
      from: 'oaid', // todo
      messageType,
      dataType,
      data
    };
    if (messageType !== MESSAGE_TYPE.FEEDBACK_REQUEST) {
      this.dispatchByData(message);
    }
    return message;
  }

  sendWithMeta(messageType, dataType, data) {
    const message = this.assembleMessage(messageType, dataType, data);
    const user = this.getUserInfo();
    const projectCode = this._projectCode;
    return {
      user,
      projectCode,
      data: message
    };
  }

  /**
   * 搜索结果
   * @param data {{content: {main: {title: String, summary: String, link: String}, others: Array<{title: String, link:
   *   String}>} | null, courtesy: String}}
   */
  handleSearchResult(data) {
    this.addMessage(data);
  }

  /**
   * 可选择的反馈类型
   * @param data {{content: [({name: String, code: Number})[]], courtesy: String}}
   */
  handleAvailableTypes(message) {
    this.availableTypes = message.data.content;
    this.addMessage(message);
  }

  /**
   * 开始收集反馈
   * @param data {{content: null, courtesy: String}}
   */
  handleReadyToListen(data) {
    this.addMessage({
      ...data,
      data: data.data.courtesy
    });
  }

  /**
   * 后端已接受反馈
   * @param data {{content: null, courtesy: String}}
   */
  handleFeedbackReceive(data) {
    this.addMessage({
      ...data,
      data: data.data.courtesy
    })
  }

  selectType(typeData) {
    this.feedbackType = typeData.code;
    return this.sendWithMeta(MESSAGE_TYPE.SELECT_TYPE, DATA_TYPE.TEXT, typeData.name);
  }

  sendFeedback(data, status) {
    const {
      text,
      images
    } = data
    const contentList = [];
    const assembleData = (dataType, value) => {
      if (!value) {
        return
      }
      const content = this.assembleMessage(MESSAGE_TYPE.FEEDBACK_CONTENT, dataType, value);
      content.feedbackType = this.feedbackType;
      content.feedbackStatus = status;
      contentList.push(content)
    }
    assembleData(DATA_TYPE.TEXT, text)
    assembleData(DATA_TYPE.IMAGE, images)
    return {
      user: this.getUserInfo(),
      projectCode: this._projectCode,
      data: contentList
    };
  }

  generatePlainText(data) {
    this.addMessage(data);
  }

  generateImage(data) {
    this.addMessage(data);
  }

  getHistory() {
    const user = this.getUserInfo();
    const projectCode = this._projectCode;
    return {
      user,
      projectCode,
      data: null
    };
  }

  addMessage(data) {
    const params = {
      ...data,
      direction: data.from === 'monkey' ? 'left' : 'right',
      name: data.from === 'monkey' ? '猴果果助手' : (this._username || '匿名'),
    }
    if (this._dispatchStatus == 'addHistory') {
      this._messageList.unshift(params);
    } else {
      this._messageList.push(params);
    }
  }
}

export const message = new Message();
